import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Offcanvas from "react-bootstrap/Offcanvas";

const Sidebar = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="sidebar">
        <NavLink
          exact
          to="/support/welcome"
          className={({ isActive }) =>
            isActive ? "active-link sidebarmainlink" : "sidebarmainlink"
          }
        >
          Welcome to tomi Help Center
        </NavLink>
        <h6 className="mainheading">Overview</h6>
        <NavLink
          exact
          to="/support/whatwedo"
          className={({ isActive }) =>
            isActive ? "active-link sidebarmainlink" : "sidebarmainlink"
          }
        >
          What we do
        </NavLink>
        {/* <NavLink
          exact
          to="/support/ourfeatures"
          className={({ isActive }) =>
            isActive ? "active-link sidebarmainlink" : "sidebarmainlink"
          }
        >
          Our Features
        </NavLink> */}
        <h6 className="mainheading">Fundamentals</h6>
        <Accordion defaultActiveKey="1">
          <Accordion.Item eventKey="0">
            <Accordion.Header as={NavLink} to="/support/gettingstarted" className={({ isActive }) => (isActive ? "active-link" : "")}>Getting Started</Accordion.Header>
            <Accordion.Body>
              <NavLink
                exact
                to="/support/chatandpayments"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Chat and Payments
              </NavLink>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div className="mobile-sidebar d-none">
        {/* <a href="/"> <img src="\logo.svg" alt="img" className='img-fluid' /></a> */}
        <a onClick={handleShow}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M3 17H21M3 12H21M3 7H21"
              stroke="#000"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>
      <Offcanvas className="mobile-offcanvas" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <img src="\logo.svg" alt="img" className="img-fluid" />
        </Offcanvas.Header>
        <Offcanvas.Body>
        <div className="sidebar">
        <NavLink
          exact
          to="/support/welcome"
          className={({ isActive }) =>
            isActive ? "active-link sidebarmainlink" : "sidebarmainlink"
          }
        >
          Welcome to tomi Help Center
        </NavLink>
        <h6 className="mainheading">Overview</h6>
        <NavLink
          exact
          to="/support/whatwedo"
          className={({ isActive }) =>
            isActive ? "active-link sidebarmainlink" : "sidebarmainlink"
          }
        >
          What we do
        </NavLink>
        <NavLink
          exact
          to="/support/ourfeatures"
          className={({ isActive }) =>
            isActive ? "active-link sidebarmainlink" : "sidebarmainlink"
          }
        >
          Our Features
        </NavLink>
        <h6 className="mainheading">Fundamentals</h6>
        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0" className="p-0">
            <Accordion.Header>Getting Started</Accordion.Header>
            <Accordion.Body>
              <NavLink
                exact
                to="/support/chatandpayments"
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                Chat and Payments
              </NavLink>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Sidebar;
